import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useGetServerDetails = () => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });

		const res = await instance.get("/configurations/environment");
		return res.data?.data;
	};
	return useQuery(["serverEnv"], () => fetch(), {
		...fetchConfig,
	});
};

export default useGetServerDetails;
